var _style, _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 647.8 626.4",
    style: {
      enableBackground: "new 0 0 647.8 626.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1D1D1B;}\n\t.st1{fill:#E6E4DA;}\n\t.st2{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M349.2,1.1c62.5-4.3,106.2,0,196.9,87.5s99.2,150,101.6,228.1c2.4,76.6-26.4,150.9-79.8,205.9 C517.2,572.6,425,636.7,306.7,625c-118.4-11.8-170-40.9-228-111.4S1.3,338.6,0,295.5S21.2,182.2,75.9,119S175.9,13.6,349.2,1.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.3,29.1c52.4-5.1,103.6-6.6,148.5,16.4s111.8,100,122.6,113.3c6.8,8.2,12.2,17.4,16,27.4 c0,0-21.9,15-13.6,53.1s22.6,53.9,28.9,59c4.2,3.3,8.8,5.9,13.8,7.9c0,0,3.9,80.4-17.2,123.4c-21.1,43-81,119.1-134.8,139.5 s-148.5,63.2-246.2,17.9S97.4,498.6,61.7,426.1S22.8,280.6,40.3,228s73.9-121.9,119.6-153.1S266.5,33,306.3,29.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M599.2,201.1c2.2,0,9.8,22.2,15.6,45.8c3.6,11.3,4.6,23.3,3.1,35.1c-11.4-9.1-19.8-21.6-23.9-35.6 C588.4,224.3,596.2,201.1,599.2,201.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M504.4,109.2c13.2,7.7,24.9,17.7,34.7,29.4c-0.8,2.7,1.1,10.1-2.8,7.4c-3.9-2.8-34.4-26.1-35.1-28.1 C500.8,114.6,502,111.4,504.4,109.2L504.4,109.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M503.2,149.3c15.6,11.7,30.2,24.9,43.4,39.2c0.2,2.6-0.6,5.3-2.2,7.4c0,0-42.6-36.6-43.8-38.2 C499.4,156.1,503.2,149.3,503.2,149.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M496.9,179.1c15,10.2,29,21.8,41.9,34.5c0,3.5-1.2,8.2-2.4,8.6c-1.1,0.4-46.5-28.5-45.8-32 C491.4,186.7,494.7,178,496.9,179.1L496.9,179.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M402.8,138.6c15.6-6.9,33.8,0.1,40.7,15.7c1.8,4.1,2.7,8.6,2.6,13.2c-0.6,22.5-19.3,40.3-41.8,39.7 c-4.1-0.1-8.2-0.8-12.1-2.2C372.8,194.3,370,151.1,402.8,138.6z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M405.7,148.3c10.8-4.8,23.4,0.1,28.2,10.9c1.3,2.9,1.9,6,1.8,9.1c-0.6,15.6-13.7,27.8-29.3,27.2 c-2.8-0.1-5.6-0.6-8.2-1.5C384.9,187.2,382.9,157.2,405.7,148.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.2,173.6c1.5,0,14.9,6.6,13.6,7.9c-11.8,12.3-20.7,27.1-25.7,43.4c-6.2,23.4-3.5,32.4-7.4,32.7 c-3.9,0.4-12.5,0-13.4-2.4c1.3-14.3,4.7-28.4,10.2-41.6C98.2,198.6,109.9,175.2,114.2,173.6L114.2,173.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M231.3,172.5c32.3-8.1,85.3,9,93,71.1c7.8,62.1-64,93.8-114.4,62.5S136.7,196.2,231.3,172.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M235.9,195.7c28.1-5.8,55.6,12.2,61.5,40.3c0.5,2.6,0.9,5.2,1,7.8c5.2,42.1-43.4,63.5-77.5,42.6 S171.9,211.8,235.9,195.7L235.9,195.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.9,330.6c6.9-3,26.1,0,26.9,25.9s-16.4,40.2-35.1,35.5S73.2,346.7,109.9,330.6L109.9,330.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.7,344.7c7.9-2.5,16.9,6.6,15.6,18c-1.2,11.4-11.2,24.1-23.4,19.5c-9.5-6.3-12.1-19.1-5.8-28.6 C101.2,348.9,106.1,345.7,111.7,344.7z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M299.2,412.3c17.2-9.2,34.7-3.6,39.1,15.1c5.2,16.5-4,34-20.4,39.2c-3.1,1-6.4,1.5-9.7,1.4 c-16-1.1-28-15-26.9-31C282,426.1,289,416.5,299.2,412.3L299.2,412.3z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M305.2,423.6c6.6-5.1,16.1-3.8,21.2,2.8c2.3,3,3.4,6.7,3.1,10.4c0.6,10.8-7.7,20.1-18.5,20.7 c-2.9,0.2-5.8-0.3-8.5-1.4C289.5,449.8,288.8,433.3,305.2,423.6L305.2,423.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.7,445.1c1.6,1.6,0,8.6,9.4,16.4c9.4,7.8,14.1,7.9,13.2,10.6c-0.9,2.7-1.5,5.9-4.2,5.9 c-7-2.5-13.4-6.5-18.8-11.7c-6.2-5.9-12.5-18.8-9.4-20C177.1,445.4,180.4,445,183.7,445.1L183.7,445.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.2,448.2c3.8,9.9,9.6,19,17,26.6c12.5,12.5,20.4,15.1,19.1,17.9c-1.2,2.8-4.6,6.6-7.4,5.5 c-9.7-7.4-18.5-15.8-26.5-25c-7.5-8.6-15.2-21.1-13.4-23C147.9,448.3,157.2,448.2,157.2,448.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.3,451.7c6.8,12.7,14.6,24.7,23.5,36c13.6,15.2,20.6,16.8,19.9,19.1c-0.6,2.7-3.1,4.7-5.9,4.6 c-3.9,0-20.8-15.2-32.7-29.2s-18.4-24.2-16.1-26.1C125.5,454.1,129.3,452.7,133.3,451.7L133.3,451.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M413,506.5c18-1.1,26.1,7,21.4,27.8c-4.8,20.8-21.9,18.8-32.8,12.5C390.8,540.5,380.2,508.3,413,506.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M413.8,516.6c6.9,0.5,12.1,6.4,11.6,13.3c-0.1,1.6-0.5,3.2-1.3,4.7c-2.9,5.3-9.5,7.2-14.7,4.4 c-1.9-1-3.4-2.5-4.4-4.4c-3.2-6.1-0.8-13.7,5.4-16.8C411.5,517.2,412.6,516.8,413.8,516.6L413.8,516.6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M484.4,357.6c31.4-7.4,46.5,2.4,55.1,35.5s-22.2,56.8-46.5,61.8c-24.3,5-35.9,3.1-49.2-27.4 C430.4,397,441.2,367.7,484.4,357.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M480.9,369.3c10.4-3.2,32.9-10.6,41.9,14c9,24.6,7.8,39.9-12.5,52.4s-29,15.4-48.6-2 C442,416.3,438.8,382.6,480.9,369.3L480.9,369.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M583.7,313.6c10.6,8.9,19.7,19.5,27,31.2c0,3.1-2,7.7-3.5,7c-11-8.8-21.1-18.8-30.1-29.6 C577.4,319.3,580.9,313.6,583.7,313.6L583.7,313.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M565.7,332.2c0,2.5,37.5,40.2,37.5,43.8c0,3.5-1.1,8.2-2.6,7.4c-14.8-13.6-28.6-28-41.5-43.4 C559.9,338.6,565.7,331.1,565.7,332.2z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M563.8,368.6c12.5,11.4,23.9,24,34,37.5c0,2.8-2,9.4-4,8.5c-2-0.9-37.5-36.3-37.5-37.5 C556.3,375.8,561.7,368.1,563.8,368.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.89c78621c64b2f283217086856a45fb4.svg";
export { ForwardRef as ReactComponent };